import React, { useState } from "react";
import "./Spin_Wheel_holder.css";

function Spin_Wheel_holder() {
  const [spinning, setSpinning] = useState(false);

  const handleSpin = () => {
    if (spinning) return;

    setSpinning(true);

    setTimeout(() => {
      setSpinning(false);
    }, 4000);
  };

  return (
    <>
      <section className="Spin_Wheel_holder">
        <div className="bg_holder">
          <img
            src="/assets/images/invite_wheel/wheen_bg.png"
            className="bg_img"
            alt="bg"
          />
        </div>

        <div className="stand_holder">
          <img
            src="/assets/images/invite_wheel/stand.png"
            className="stand_img"
            alt="stand"
          />
        </div>

        <div className="wheel_holder">
          <div className="wheel_spin_holder">
            <img
              src="/assets/images/invite_wheel/wheel.png"
              className={`wheel_img ${spinning ? "spin" : ""}`}
              alt="wheel"
            />

            <img
              src="/assets/images/invite_wheel/spin_btn.png"
              className="Spin_Btn_img"
              alt="spin_Btn"
              onClick={handleSpin}
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Spin_Wheel_holder;